<div class="badge-overview-list badges-list-container">
  <!--Badge List-->
  <ng-container *ngIf="badgeByCategories$ | async as badgesByCategories">
    <ng-container *ngIf="badgesByCategories && badgesByCategories.length">
      <ng-container *ngFor="let category of badgesByCategories">
        <h2
          class="badge-subheading mt-4 mb-0"
          attr.aria-label="{{ 'badge.category.headers.screenreader' | translate: { category: category.Title } }}"
        >
          {{ category.Title }}
        </h2>
        <div class="row">
          <ng-container *ifScreenSize="screenType.Desktop">
            <div *ngFor="let badge of category.Badges" [class.col-lg-2]="isList" [class.col-md-4]="isList" [class.col-4]="isList">
              <fgbcl-badge-list-item
                [badge]="badge"
                [confettiColors]="confettiColors"
                [isSponsorInBody]="isSponsorInBody"
              ></fgbcl-badge-list-item>
            </div>
          </ng-container>
          <ng-container *ifScreenSize="screenType.Mobile">
            <div
              *ngFor="let badge of category.Badges"
              data-bs-dismiss="offcanvas"
              [class.col-lg-2]="isList"
              [class.col-md-4]="isList"
              [class.col-4]="isList"
            >
              <fgbcl-badge-list-item
                [badge]="badge"
                [confettiColors]="confettiColors"
                [isSponsorInBody]="isSponsorInBody"
              ></fgbcl-badge-list-item>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="showPlaceholder">
      <div class="challenges-placeholder" *ngIf="badgesByCategories.length == 0">
        <!--Badges Placeholder-->
        <div class="no-items m-0 no-results-placeholder-div">
          <div
            class="svg svg-info vs-svg ms-auto me-auto"
            fgbAnimateSvg
            [inlineSVG]="'assets/images/placeholders/Badges.svg'"
          ></div>
          <div class="no-results-placeholder">{{ 'badges.placeholder.description' | translate }}</div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
